import { axiosInstance, baseURL, baseURL_v2, handleErrors } from './auth'

export const BOOKING_REPORTS = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseURL}/user/report/booking`, params)
        return response.data
    } catch (error) {
        handleErrors(error)
    }
}

export const USER_REPORTS = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseURL_v2}/reports/userReport`, params)
        return response.data
    } catch (error) {
        handleErrors(error)
    }
}

export const FINANCIAL_REPORTS = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseURL_v2}/reports/financialReport`, params)
        return response.data
    } catch (error) {
        handleErrors(error)
    }
}
export const FEEDBACK_RATING_REPORTS = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseURL_v2}/reports/feedbackAndRatingReports`, params)
        return response.data
    } catch (error) {
        handleErrors(error)
    }
}
export const SERVICE_REPORTS = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseURL_v2}/reports/serviceRequestReport`, params)
        return response.data
    } catch (error) {
        handleErrors(error)
    }
}

export const PAYMENT_REPORTS = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseURL}/user/report/payment`, params)
        return response.data
    } catch (error) {
        handleErrors(error)
    }
}
export const GET_VENDOR_REPORT = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseURL}/vendor/reportAnalytic`, params)
        return response.data
    } catch (error) {
        handleErrors(error)
    }
}
export const GET_VENDOR_LIST_FILTER = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseURL}/vendor/vendorAllList`, params)
        return response.data
    } catch (error) {
        handleErrors(error)
    }
}
export const GET_VENDOR_EVENT_LIST_FILTER = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseURL}/vendor/vendorAllEventList`, params)
        return response.data
    } catch (error) {
        handleErrors(error)
    }
}
